// currently unused
export const enabledUnitsOnStart = {
  /* fighter: false,
  archer: false,
  knight: false,
  mage: false,
  bombird: false, */
};
